import { render } from "./iconFoco.vue?vue&type=template&id=9a09061a&scoped=true"
import script from "./iconFoco.vue?vue&type=script&lang=js"
export * from "./iconFoco.vue?vue&type=script&lang=js"

import "./iconFoco.vue?vue&type=style&index=0&id=9a09061a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a09061a"

export default script